import {cva} from 'class-variance-authority';

export const toggleGroupVariants = cva(
  'flex flex-wrap items-center gap-1 rounded-full p-1',
  {
    variants: {
      variant: {
        default: 'bg-transparent',
        background: 'bg-neutral-50',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
